import type { SVGProps } from 'react';

const SvgFileExport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 19.023H6c-.55 0-1-.45-1-1v-12c0-.55.45-1 1-1h2v3c0 1.65 1.35 3 3 3h3v1c0 .55.45 1 1 1s1-.45 1-1v-3.59c0-.53-.21-1.04-.59-1.41L12 3.612c-.38-.38-.88-.59-1.41-.59H6c-1.65 0-3 1.35-3 3v12c0 1.65 1.35 3 3 3h6c.55 0 1-.45 1-1s-.45-1-1-1Zm-1.41-14L14 8.432v.59h-3c-.55 0-1-.45-1-1v-3z"
    />
    <path
      fill="currentcolor"
      d="M20.92 16.402a1 1 0 0 0 0-.76.9.9 0 0 0-.22-.32l-2-2a.996.996 0 1 0-1.41 1.41l.29.29h-5.59c-.55 0-1 .45-1 1s.45 1 1 1h5.59l-.29.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2-2c.09-.09.17-.2.22-.32z"
    />
  </svg>
);
export default SvgFileExport;
